/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Default_Confirmation_DescriptionInputs */



/**
* | output |
* | --- |
* | "How cautiously a new agent acts. Levels your organization does not allow are not available." |
*
* @param {Agent_Policy_Default_Confirmation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_default_confirmation_description = /** @type {((inputs?: Agent_Policy_Default_Confirmation_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Default_Confirmation_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie vorsichtig ein neuer Agent handelt. Stufen, die Ihre Organisation nicht erlaubt, stehen nicht zur Verfügung.")
	return /** @type {LocalizedString} */ ("How cautiously a new agent acts. Levels your organization does not allow are not available.")
});